<template>
    <div>
        <md-table v-model="proposals" md-card dir="rtl">
        <md-table-toolbar>
            <h1 class="md-title text-center">پیشنهاد های تراکنش های ققنوسی</h1>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{item}">
            <md-table-cell md-label="کد پیشنهاد"  md-numeric>{{ item.id }}</md-table-cell>
            <md-table-cell md-label="عنوان پیشنهاد"  md-numeric> {{item.title}} </md-table-cell>
            <md-table-cell md-label="xdr تراکنش"  md-numeric> <textarea name="" id="" cols="30" rows="10" readonly :value="item.url"></textarea> </md-table-cell>
            <md-table-cell md-label="هش تراکنش "  md-numeric> <textarea name="" id="" cols="30" rows="3" :value="item.hash"></textarea> </md-table-cell>
            <md-table-cell md-label="پیشنهاد دهنده "  md-numeric> {{item.author}} </md-table-cell>
            <md-table-cell md-label="مشاهده ی امضاکنندگان"  md-numeric> 
                <md-button @click="()=>{seeSigners(item.id)}">   لیست امضاکنندگان  </md-button>    
             </md-table-cell>

        </md-table-row>
        </md-table>
        <modal name="signers" :width="'900px'">
            <md-card >
              <md-card-header style="text-align:center" class="md-title">فهرست امضاها</md-card-header>
              <md-list v-if="signers.length !=0">
                  <md-list-item v-for="sign in signers" style="text-align:center">{{sign}}</md-list-item>
              </md-list>
              <div v-else>
                <p class="text-center">امضاکننده ای وجود ندارد</p>
              </div>
            </md-card>
        </modal>

    </div>
</template>
<script>
import ContractUtils from '../contract'
import { mapGetters, mapActions } from 'vuex';
import async from 'async'
import moment from 'moment-jalaali'
import { setTimeout } from 'timers';
export default {
    computed:mapGetters(['account','contract','net_members']),
    data:()=>({
        proposals:[],
        signers:[],
        anchors:[],
        proposals_count:0,
    }),
    mounted(){

        this.fetchData();
        this.$store.subscribe((mutation,state)=>{
            switch (mutation.type) {
            case 'set_contract':
                if(state.contract){
                this.fetchData()
                }
                break;
            
            default:
                break;
            }
        })
    },
    methods:{
      ...mapActions(['set_members']),
        seeSigners(id){
          this.signers = [];
            let contract = ContractUtils.getContract();
            if(contract)
            this.net_members
                .map(member=>member.member)
                .forEach(memberAddress=>{
                  console.log(`${id} is id and members are :${memberAddress}`)
                    contract.methods
                        .votesReceived(id,memberAddress)
                        .call()
                        .then(data=>{
                          console.log(data)
                            if(data.description)
                                this.signers.push(data.description)
                        })
                    }
                );
                console.log(this.signers)
                this.$modal.show('signers')
        },
        fetchData(){
        this.$Progress.start()
        let contract = ContractUtils.getContract();
        if(contract.methods)
        {
            contract.methods
              .getProposalsCount()
              .call()
              .then(data=>{
                  this.proposals_count = parseInt(data.toString());
                  async.each(Array.from(Array(this.proposals_count).keys()),(proposal_id,next)=>{
                      contract.methods
                        .getProposal(proposal_id)
                        .call({from:this.account})
                        .then(data=>{
                          let proposal =  {
                              id:proposal_id,
                              title:data.title,
                              proposalType:parseInt(data.proposalType.toString()),
                              hash:data.hashCode,
                              url:data.url,
                              //up:parseInt(data.up.toString()),
                              //down:parseInt(data.down.toString()),
                              author:data.author
                            }
                          contract.methods.getProposalStatus(proposal_id)
                            .call({from:this.account})
                            .then(data1=>{
                              if(data1)
                              {
                                proposal.up = parseInt(data1.up.toString())
                                proposal.down = parseInt(data1.down.toString())
                              }
                              else
                              {
                                proposal.up =0
                                proposal.down = 0
                              }
                              this.proposals.push(proposal);
                              next()
                            }).catch(err=>{
                            })
                        }).catch(err=>{
                        })
                    },(err)=>{
                      this.proposals = this.proposals.filter(proposal=>proposal.proposalType == 7);
                      this.$Progress.finish()

                    })
                        
                  }
                ).catch(err=>{
              })
            
            contract.methods
              .getAnchorsCount()
              .call()
              .then(data=>{
                this.anchors_count = parseInt(data.toString())
                async.each(Array.from(Array(this.anchors_count).keys()),(anchor_id,next1)=>{
                    contract.methods
                      .anchors(anchor_id)
                      .call({from:this.account})
                      .then(data=>{
                        let anchor= {
                          name:data.name,
                          url:data.url,
                          nameHash:data.nameHash,  
                          members:[]
                        };
                        this.anchors.push(anchor);
                        next1();
                      }).catch(err=>{
                      })
                },(err)=>{
                    this.anchors
                      .forEach((anchor)=>{
                        // let member={
                        //   anchor:nameHash,
                        //   members:[]
                        // };
                        //member.anchor = nameHash;
                        async.times(2,(id,next2)=>{
                          contract.methods 
                            .anchorMembers(anchor.nameHash,id)
                            .call()
                            .then(data=>{
                              this.members.push({anchor:anchor.nameHash,member:data})
                              next2()
                            }).catch(err=>{
                            })
                        },(err,final)=>{
                          this.set_members(this.members)
                        }
                      
                      )
                    })
                  }
                )
              }).catch(err=>{
            })              
          }    
        }
    }
}
</script>
<style scoped>
  .md-table{
    padding:1em
  }
</style>
